import React, { useEffect, useState } from 'react';
import { Tabs } from 'antd';
import styles from './position-status-position-insigts.module.scss';
import { left_down_icon } from './../../../../assets/img';
import PositionStatusPositionInsightsChart from '../PositionStatusPositionInsightsChart/PositionStatusPositionInsightsChart';
import { useSelector } from 'react-redux';
import { CRITICAL_POSITION_CATERORY, KEY_NAME_POSITION_STATUS, POSITION_STATUS_TAB } from '../../talent-analytics.constant';
import { talentAnalyticApi } from '../../../../services/talentAnalyticApi';

const { TabPane } = Tabs;

const PositionStatusPositionInsights = ({ activeKey, setActiveKey, totalPositionStatus, setLoading, setStackChartData, handleOnClickReport }) => {
  const [data, setData] = useState({});
  const roleActive = useSelector((state) => state.user.roleActive);

  const renderTabLabel = (key, label, isSub = false, number) => (
    <div className={`${!isSub ? styles.tab_wrapper : styles.sub_tab} ${activeKey === key ? styles.active : ''}`}>
      {isSub ? (
        <>
          <img src={left_down_icon} alt="left_down_icon" className={styles.image} />
          <div className={`${styles.tab_text_sub} ${activeKey === key ? styles.active : ''}`}>{label}</div>
        </>
      ) : (
        <>
          <span className={styles.number}>{number}</span>
          <span className={`${styles.tab_text} ${activeKey === key ? styles.active : ''}`}>{label}</span>
        </>
      )}
    </div>
  );

  const getPositionStatusPositionInsights = async () => {
    const payload = {
      type: activeKey,
      filters: {
        critical_position_category: CRITICAL_POSITION_CATERORY,
      },
    };
    setLoading(true);
    try {
      const response = await talentAnalyticApi.fetchPositionStatusInPositionInsights(payload);
      if (response.status === 200) {
        setData(response.data.result);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getPositionStatusPositionInsights();
  }, [activeKey, roleActive.roleId]);

  return (
    <>
      <div className={styles.header}>
        <div className={styles.title}>Distribution of positions</div>
        <div className={styles.total_title}>
          Total positions:<span className={styles.total_num}>{totalPositionStatus || ''}</span>
        </div>
      </div>

      <div className={styles.content_wrapper}>
        <Tabs tabPosition="left" activeKey={activeKey} onChange={(key) => setActiveKey(key)}>
          <TabPane
            tab={renderTabLabel(KEY_NAME_POSITION_STATUS.POSITION_APPROVED_SP, POSITION_STATUS_TAB.POSITION_APPROVED_SP, false, '1')}
            key={KEY_NAME_POSITION_STATUS.POSITION_APPROVED_SP}
          >
            <PositionStatusPositionInsightsChart
              data={data}
              setStackChartData={setStackChartData}
              handleOnClickReport={handleOnClickReport}
              type={KEY_NAME_POSITION_STATUS.POSITION_APPROVED_SP}
            />
          </TabPane>
          <TabPane
            tab={renderTabLabel(KEY_NAME_POSITION_STATUS.POSITION_WITHOUT_SP, POSITION_STATUS_TAB.POSITION_WITHOUT_SP, false, '2')}
            key={KEY_NAME_POSITION_STATUS.POSITION_WITHOUT_SP}
          >
            <PositionStatusPositionInsightsChart
              data={data}
              setStackChartData={setStackChartData}
              handleOnClickReport={handleOnClickReport}
              type={KEY_NAME_POSITION_STATUS.POSITION_WITHOUT_SP}
            />
          </TabPane>
          <TabPane
            tab={renderTabLabel(
              KEY_NAME_POSITION_STATUS.POSITION_WITHOUT_SP_NEW_POSITION,
              POSITION_STATUS_TAB.POSITION_WITHOUT_SP_NEW_POSITION,
              true,
              '3'
            )}
            key={KEY_NAME_POSITION_STATUS.POSITION_WITHOUT_SP_NEW_POSITION}
          >
            <PositionStatusPositionInsightsChart
              data={data}
              setStackChartData={setStackChartData}
              handleOnClickReport={handleOnClickReport}
              type={KEY_NAME_POSITION_STATUS.POSITION_WITHOUT_SP_NEW_POSITION}
            />
          </TabPane>
        </Tabs>
      </div>
    </>
  );
};

export default PositionStatusPositionInsights;
